import { render, staticRenderFns } from "./ProductWeightAndDimension.vue?vue&type=template&id=554c2794&scoped=true"
import script from "./ProductWeightAndDimension.vue?vue&type=script&lang=js"
export * from "./ProductWeightAndDimension.vue?vue&type=script&lang=js"
import style0 from "./ProductWeightAndDimension.vue?vue&type=style&index=0&id=554c2794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554c2794",
  null
  
)

export default component.exports